var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white rounded-xl shadow-lg p-4 sm:p-6 hover:shadow-xl transition-all duration-300 border border-gray-100",class:_vm.customClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }